import React from 'react'
import LocationPill from '../LocationPill/LocationPill'
import { Skeleton } from '@/components/layout/Skeleton/Skeleton'

export interface LocationPillsProps {
  items: Array<LocationPillsItemProps>
  onClick: (url: string) => void
}

export interface LocationPillsItemProps {
  city: string
  symbol: string
  degrees: number
  url: string
}

const LocationPills: React.FC<LocationPillsProps> = ({ items, onClick }) => {
  return (
    <div className="overflow-y-hidden remove-scrollbar">
      <div className="flex flex-row gap-2 remove-scrollbar">
        {items?.length === 0 &&
          [...Array(2)].map((_, idx) => (
            <Skeleton
              key={idx}
              className="xs:h-auto h-[34px] w-[120px] rounded-full"
            />
          ))}
        {items?.map((item) => (
          <LocationPill
            key={item.city}
            city={item.city}
            symbol={item.symbol}
            degrees={item.degrees}
            onClick={() => onClick(item.url)}
            className="animate-fade-in"
          />
        ))}
      </div>
    </div>
  )
}

export default LocationPills
